import { Icon } from '@iconify/react'
import { useStorefrontContent, useBranding } from '@/branding/BrandingProvider'

export function FooterSection() {
  const { footer } = useStorefrontContent()
  const { siteName } = useBranding()

  return (
    <footer className="bg-slate-50 border-t border-slate-200 py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded bg-navy flex items-center justify-center">
            <Icon icon="solar:health-linear" className="text-white text-xs" />
          </div>
          <span className="text-lg font-medium tracking-tight text-navy">{siteName}</span>
        </div>
        <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-500 font-light">
          {footer.links.map((link) => (
            <a key={link.label} href={link.href} className="hover:text-navy">
              {link.label}
            </a>
          ))}
        </div>
        <div className="text-sm text-slate-400 font-light">{footer.copyright}</div>
      </div>
    </footer>
  )
}
